import React from "react";
import { Button } from "../design/button";

import logo from "../assets/logo.png";

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gallery-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        <div className="bg-white border border-gallery-200 rounded-sm p-10">
          <img src={logo} alt="Art Collection" className="w-20 h-20 mx-auto mb-8" />

          <h1 className="font-display text-display-sm text-gallery-900 mb-3">
            Art Collection
          </h1>
          <p className="text-gallery-500 mb-8 leading-relaxed">
            Partner Portal for accessing the Art Collection API and market intelligence tools.
          </p>

          <div className="space-y-3">
            <Button href="/login" className="w-full">
              Sign In
            </Button>
            <Button href="/register" outline className="w-full">
              Create Account
            </Button>
          </div>
        </div>

        <div className="mt-8 space-y-2">
          <p className="text-xs text-gallery-400">
            AI-powered art market analytics
          </p>
          <div className="flex items-center justify-center gap-6 text-xs text-gallery-400">
            <a href="https://www.artcollection.io/terms" className="hover:text-gallery-600 transition-colors">
              Terms
            </a>
            <a href="https://www.artcollection.io/privacy" className="hover:text-gallery-600 transition-colors">
              Privacy
            </a>
            <a href="mailto:info@artcollection.io" className="hover:text-gallery-600 transition-colors">
              Contact
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
